import { bl_ppl_ap_validation_test_file_zip_helper_RowClass } from '../../../dbschema/bl_ppl_ap_validation_test_file_zip_helper.model';
import { BaseContainerModel } from '../../base-container.model';

export class PeppolAPTestbedValidationTestFileHelperContainerModel extends BaseContainerModel {
    bl_ppl_ap_validation_test_file_zip_helper: bl_ppl_ap_validation_test_file_zip_helper_RowClass = new bl_ppl_ap_validation_test_file_zip_helper_RowClass();
}